// extracted by mini-css-extract-plugin
export default {"verweis":"style_verweis__PdTLG"};